import { AlphaEIcon } from './AlphaEIcon';

/**
 * author: GreenTurtwig
 * id 3B3F5AA2-8A97-4A66-BD4A-7AA105901B61
 * name alpha-e
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-e.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetEIcon = AlphaEIcon;
export default AlphabetEIcon